module.exports = {
  emptyMessage: 'Lütfen kartın son kullanma tarihini girin',
  expiredMessage: 'Girdiğiniz kartın süresi dolmuş',
  defaultMessage: 'Son kullanma tarihi geçersiz',
};
